/**
 * Base Item used for an accordion UI
 */
export class Entry<T> {
  constructor(
    public title: string,
    public body: string, // TODO: Remove if this is no longer used
    public array: Array<T | any>,
    public isExpanded: boolean,
    public match: string
  ) {}
}
